// WCAG contrast helpers. Used by the colour picker to flag accent colours
// that won't pass AA on white.

function hexToRgb(hex: string) {
  const m = hex.replace("#", "").match(/.{1,2}/g);
  if (!m || m.length !== 3) return { r: 0, g: 0, b: 0 };
  return { r: parseInt(m[0]!, 16), g: parseInt(m[1]!, 16), b: parseInt(m[2]!, 16) };
}

function luminance(hex: string) {
  const { r, g, b } = hexToRgb(hex);
  const [R, G, B] = [r, g, b].map((c) => {
    c /= 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }) as [number, number, number];
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

export function contrast(a: string, b: string) {
  const la = luminance(a);
  const lb = luminance(b);
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}

export type ContrastRating = {
  lvl: "ok" | "warn" | "bad";
  label: string;
  help: string;
  ratio: number;
};

export function ratingFor(ratio: number): ContrastRating {
  if (ratio >= 4.5) return { lvl: "ok",   label: "AA passes",        help: `${ratio.toFixed(2)}:1`, ratio };
  if (ratio >= 3.0) return { lvl: "warn", label: "Large text only",  help: `${ratio.toFixed(2)}:1`, ratio };
  return { lvl: "bad", label: "Fails AA — contrast too low", help: `${ratio.toFixed(2)}:1`, ratio };
}
